<template>
  <div class="gonggao_wrap centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>通知公告</span>
    </div>
    <div class="new-w9 centerWidth">
      <div class="new-tit-3 d-flex d-align-center">
        <div class="line"></div>
        <div class="tit cur">通知公告</div>
      </div>
<!--      <div class="list_div">-->
<!--        <div class="news_a d-flex d-align-center d-just-between"  @click="toDetails(item)" v-for="(item,index) in gonggaoList" :key="index">-->
<!--          <div class="d-flex d-align-center" style="width: 86%">-->
<!--            <div class="dian"></div>-->
<!--            <div class="text_ov eli1">{{item.title}}</div>-->
<!--          </div>-->
<!--          <div class="date" v-if="item.create_time">{{item.create_time.split(' ')[0]}}</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-if="gonggaoList.length>0">
      <div class="gonggao_list">
        <div class="gonggao_item" @click="toDetails(item)" v-for="(item,index) in gonggaoList" :key="index">
          <div class="jiantou"></div>
          <div class="gonggao_top">
            <div class="gonggao_date">
              <span>{{ item.create_time.slice(8, 10) }}</span>
              <span>{{ item.create_time.slice(0, 7) }}</span>
            </div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div style="text-align: center;padding: 30px 0 50px 0">
        <el-pagination
            :page-size="10"
            :current-page="pageNum"
            :background="true"
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <noData v-else>
      没有相关内容~
    </noData>
  </div>
</template>

<script>
import {
		articlelists
	} from "@/api/index";

export default {
  name: "announcement",
  data() {
    return {
      pageNum: 1, // 当前页数
      total: 0, // 列表总条数
      gonggaoList: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      let ajaxData = {
        page_size: 10,
        page_no: this.pageNum,
		cid:1
      }
      articlelists(ajaxData).then(res => {
        if (res.code == 1) {
          let list = res.data.lists
          this.gonggaoList = list
          this.total = res.data.count
        }
      })
    },
    toDetails(item) {
      if (item.url) {
        window.open(item.url)
      }else{
        this.$router.push({
          path: 'detail',
          query: {
            id: item.id,
            type:1
          }
        })
      }
    },
    currentChange(val) {
      this.pageNum = val
      this.getList()
    },
  }
}
</script>

<style scoped lang="scss">
.new-w9 {
  margin-top: 30px;

  .new-tit-3 {
    background: #f6f5f5;
    font-size: 20px;
    font-weight: bold;

    .line {
      margin-right: 15px;
      width: 5px;
      height: 48px;
      background: #2257ab;
      border-radius: 2px;
    }
  }

  .list_div {
    margin-top: 30px;

    .news_a {
      height: 48px;
      cursor: pointer;
      border-bottom: 1px dashed #EEEEEE;
      &:hover .text_ov{
        color: #2257ab;
      }

      .dian{
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #2257ab;
        margin-right: 10px;
      }
      .text_ov {
        font-size: 18px;
        color: #333333;
      }
      .date {
        color: #666666;
        font-size: 14px;
      }
    }
  }
}

.gonggao_list {
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;

  .gonggao_item {
    cursor: pointer;
    position: relative;
    margin-bottom: 24px;
    width: 588px;
    height: 105px;
    background: #fff;
    -webkit-box-shadow: 0 10px 40px 0 rgba(5, 18, 35, .06);
    box-shadow: 0 10px 40px 0 rgba(5, 18, 35, .06);
    padding: 0 30px 0 30px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    box-sizing: border-box;
    border-radius: 8px;
  }

  .gonggao_item:hover {
    .jiantou {
      width: 40px;
      height: 10px;
    }

    .gonggao_top > div:nth-child(2) {
      color: #2257ab;
    }
  }

  .gonggao_item:nth-child(odd) {
    margin-right: 24px;
  }

  .jiantou {
    position: absolute;
    right: 30px;
    bottom: 20px;
    background-image: url("../assets/images/jiantou.png");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    align-self: flex-end;
  }

  .gonggao_top {
    display: flex;
  }

  .gonggao_date {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 70px;
    height: 80px;
    background: #2257ab;
    border-radius: 0 0 20px 0;
    align-items: center;
    position: absolute;
    left: 28px;
    top: 0;
  }

   .gonggao_item {

     &:first-child {
       .gonggao_date{
         background: #cfaa5c !important;
       }
     }
     &:nth-child(4) {
       .gonggao_date{
         background: #cfaa5c !important;
       }
     }

     &:nth-child(5) {
       .gonggao_date{
         background: #cfaa5c !important;
       }
     }
     &:nth-child(8) {
       .gonggao_date{
         background: #cfaa5c !important;
       }
     }
     &:nth-child(9) {
       .gonggao_date{
         background: #cfaa5c !important;
       }
     }
  }

  .gonggao_date > span:first-child {
    font-size: 32px;
    font-family: Arial;
    font-weight: 700;
    color: #fff;
  }

  .gonggao_date > span:nth-child(2) {
    font-size: 16px;
    font-family: Arial;
    font-weight: 700;
    color: #fff;
  }

  .gonggao_top > div:nth-child(2) {
    align-self: center;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 700;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 90px;
    flex: 1;
	margin-top: 30px;
  }

  .gonggao_content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #5a5f66;
    margin-top: 50px;
  }
}
</style>
